module.exports = "<span style=\"font-size: 18px;\" *ngIf=\"accountingBlock != null\">\n    - Bloqueio de Período Contábil: <strong>{{accountingBlock.competence}}/{{accountingBlock.competenceYear}}</strong>\n </span>\n<span *ngIf=\"accountingBlock != null\" class=\"tip-accounting\" data-placement=\"right\">?</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/accounting-block/accounting-block.component.html
// module id = ./src/app/shared/components/accounting-block/accounting-block.component.html
// module chunks = main